(ns pfo.widget.countdown
  (:require [reagent.core :as reagent :refer [atom]]
            [cljs-time.core :as time-core :refer [seconds plus in-minutes in-seconds interval]]
            [pfo.time :refer [now time-shift-millis]]))

(declare timer-fn)

(defn countdown
  ; https://www.reddit.com/r/Clojurescript/comments/5htkbc/how_to_use_the_withlet_macro_in_reagent_060/
  [options creation-time allowed-interval title]
  (reagent/with-let [seconds-left (atom (in-seconds (interval
                                                      (now)
                                                      (apply plus (filterv identity [creation-time
                                                                                     allowed-interval
                                                                                     (when (:apply-time-shift options) time-shift-millis)])))))
                     timer-fn     (js/setInterval #(if (> @seconds-left 0)
                                                     (swap! seconds-left dec)
                                                     (js/clearInterval timer-fn))
                                                  1000)]
    [:span.timer {:class (:class options)}
     [:span (str title ": ") [:label (str (in-minutes (seconds @seconds-left)) ":"
                                         (if (< (mod @seconds-left 60) 10)
                                           (str "0" (mod @seconds-left 60))
                                           (mod @seconds-left 60)))]]]
    (finally (js/clearInterval timer-fn))))

(defn countdown-for-ability [options creation-time allowed-interval edit-ability-atom delete-ability-atom]
  (if (or
          (= :edit-with-timer @edit-ability-atom)
          (= :delete-with-timer @delete-ability-atom))
    [:span.u-margin-right--xs
     [countdown nil creation-time allowed-interval
      (cond
        (and
          (= :edit-with-timer @edit-ability-atom)
          (= :delete-with-timer @delete-ability-atom)) "Time to edit/delete"
        (= :edit-with-timer @edit-ability-atom) "Time to edit"
        (= :delete-with-timer @delete-ability-atom) "Time to delete")]]
    [:span]))
